import * as actionTypes from "./actionTypes";
import { customerService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";

export function getCustomers({ page = constants.GET_ALL_ITEMS, filter, reset } = {}) {
  return async dispatch => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_CUSTOMERS });

      dispatch({ type: actionTypes.FETCH_CUSTOMERS });

      const response = await customerService.getAll(page, filter);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_CUSTOMERS_FAILURE,
          payload: { error: data.message }
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_CUSTOMERS_SUCCESS,
        payload: {
          customers: data.data,
          total: data.quantity,
          pageSize: data.pageSize
        }
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_CUSTOMERS_FAILURE);
    }
  };
}

export function getCustomersByPrefix(prefix, reset) {
  return async dispatch => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_CUSTOMERS_BY_PREFIX });

      dispatch({ type: actionTypes.FETCH_CUSTOMERS_BY_PREFIX });

      const response = await customerService.findCustomersWithPrefix(prefix);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_CUSTOMERS_BY_PREFIX_FAILURE,
          payload: { error: data.message }
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_CUSTOMERS_BY_PREFIX_SUCCESS,
        payload: {
          customers: data.data
          // total: data.quantity,
          // pageSize: data.pageSize
        }
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_CUSTOMERS_FAILURE);
    }
  };
}
export function resetCustomers() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_CUSTOMERS
    });
  };
}
export function getCustomer(id) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.RESET_CUSTOMER });
      dispatch({ type: actionTypes.FETCH_CUSTOMER });

      const response = await customerService.get(id);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_CUSTOMER_FAILURE,
          payload: { error: data.message }
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_CUSTOMER_SUCCESS,
        payload: { customer: data }
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_CUSTOMER_FAILURE);
    }
  };
}

export function bulkLoadCustomer(file) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.BULK_LOAD_CUSTOMERS });

      const response = await customerService.bulkLoadCustomer(file);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.BULK_LOAD_CUSTOMERS_FAILURE,
          payload: { error: data.message }
        });

        return;
      }

      dispatch({
        type: actionTypes.BULK_LOAD_CUSTOMERS_SUCCESS,
        payload: { value: data }
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.BULK_LOAD_CUSTOMERS_FAILURE);
    }
  };
}

export function resetBulkLoad() {
  return dispatch => {
    dispatch({
      type: actionTypes.BULK_LOAD_CUSTOMERS_RESET
    });
  };
}

export function resetCustomer() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_CUSTOMER
    });
  };
}

export function getCustomerSells({ page = constants.GET_ALL_ITEMS, startDate, endDate, id } = {}) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.RESET_CUSTOMER_SELLS });
      dispatch({ type: actionTypes.FETCH_CUSTOMER_SELLS });

      const response = await customerService.getSells(page, startDate, endDate, id);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_CUSTOMER_SELLS_FAILURE,
          payload: { error: data.message }
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_CUSTOMER_SELLS_SUCCESS,
        payload: {
          sells: data.data,
          total: data.quantity,
          pageSize: data.pageSize
        }
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_CUSTOMER_SELLS_FAILURE);
    }
  };
}
export function resetCustomerSells() {
  return dispatch => {
    dispatch({
      type: actionTypes.RESET_CUSTOMER_SELLS
    });
  };
}


// mobile
export function resetPassword(token, password, confirmPassword) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.RESET_CUSTOMER_RESET_PASSWORD });
      dispatch({ type: actionTypes.CUSTOMER_RESET_PASSWORD });

      await customerService.resetPassword(token, password, confirmPassword);

      dispatch({ type: actionTypes.CUSTOMER_RESET_PASSWORD_SUCCESS });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.CUSTOMER_RESET_PASSWORD_FAILURE);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/customer/actions.js